module.exports = __webpack_public_path__ + "img/btn-selected-bg.f87cbb04.png";